import { Box, Heading, List, Stack, Text, TextLink } from 'braid-design-system';

import { PaymentSuccessCta } from './components/PaymentSuccessCTA';
import { PaymentSuccessLayout } from './components/PaymentSuccessContainer';

export const AcceleratePaymentSuccess = () => {
  const enquiriesEmailLink = `mailto:enquiries@seekbusiness.com.au?subject=${encodeURIComponent(
    'Purchase Assistance | Accelerate List Until Sold ad',
  )}`;

  return (
    <Box data={{ testid: 'accelerate-payment-success' }}>
      <PaymentSuccessLayout
        callToAction={<PaymentSuccessCta>Next</PaymentSuccessCta>}
      >
        <Stack space="large">
          <Heading level="3" component="h1">
            Purchase success!
          </Heading>

          <Stack space="large">
            <Stack space="medium">
              <Text>We&apos;ve received your order for:</Text>

              <List space="small">
                <Text>List Until Sold ad</Text>
                <Text>Website Search Boost</Text>
                <Text>Email Boost</Text>
              </List>
            </Stack>

            <Text>
              You will receive an email to confirm your purchase and your ad
              will automatically be boosted. No further action is required on
              your part.
            </Text>

            <Text>Get ready to accelerate your business sale.</Text>

            <Stack space="medium">
              <Text>Having troubles?</Text>
              <Text
                data={{
                  testid: 'accelerate-payment-success-contact-us',
                }}
              >
                Contact us at{' '}
                <TextLink href={enquiriesEmailLink}>
                  enquiries@seekbusiness.com.au
                </TextLink>
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </PaymentSuccessLayout>
    </Box>
  );
};
